import * as angular from 'angular';
import { map, DoughnutChart, SeriesFormat } from '../../../charting/charts/DoughnutChart';
import { SvgManager, Margins } from '../../..';
import { IDynamicCompileService } from '../../services/dynamicCompileService';

class DoughnutChartController implements angular.IComponentController,
    angular.IOnInit,
    angular.IOnChanges {

    componentId: string;

    readonly data: any[];
    readonly options: any;
    readonly ratio?: number;
    readonly series: SeriesFormat[];

    private _chart: DoughnutChart<any>;

    static $inject = ['$scope', '$element', 'dynamicCompileService'];
    constructor(private _$scope: angular.IScope,
        private _$element: angular.IAugmentedJQuery,
        private _dynamicCompileService: IDynamicCompileService) {
    }

    $onInit(): void {
        const id = this.componentId;
        if (!id) {
            console.error('Cannot use doughut chart. An id is required.');
        } else {
            this._$element.attr('id', id);
            // select the div below custom element
            const svgManager = new SvgManager(id + ' div.doughnut-chart-container', new Margins(0, 0, 0, 0));
            this._chart = new DoughnutChart(svgManager);
            this.update();
        }
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        this.update();
        if (changesObj['series'] && this.series.filter(s => !!s.attributes).length) {
            this._dynamicCompileService.compileGroup(this._$element, this._$scope as any, null, this.series);
        }
    }

    private update() {
        if (this.series && this.data && this.options && this._chart) {
            const mapped = map(this.series, this.data, this.options);
            this._chart
                .ratio(this.ratio || 1)
                .options(this.options)
                .update(mapped);
        }
    }
}

export const wtDoughnutChart: angular.IComponentOptions & { componentId: string } = {
    componentId: 'wtDoughnutChart',
    controller: DoughnutChartController,
    template: '<div class="full-size doughnut-chart-container"><svg></svg></div>',
    controllerAs: 'vm',
    bindings: {
        componentId: '@',
        data: '<',
        options: '<',
        ratio: '<?',
        series: '<'
    }
};
